import { Link } from 'react-router-dom';
import Seo from '../components/Seo';
import { waLink } from '../lib/contact';
import { breadcrumb } from '../lib/seo-schemas';

const WA_BEBIDAS = waLink('Hola Bar Cabrero! Una pregunta sobre las bebidas. Gracias!');

const COLS = [
  { cat: 'Vinos', items: [
    { n: 'Blanco de la Nava',     b: 'Estrella de la casa' },
    { n: 'Rioja por copa',        b: 'Crianza' },
    { n: 'Ribera del Duero',      b: 'Tinto' },
    { n: 'Manzanilla de Sanlúcar',b: 'Fino' },
    { n: 'Txakoli',               b: 'De temporada' },
  ]},
  { cat: 'Cervezas & Vermut', items: [
    { n: 'Caña bien tirada',          b: 'Imprescindible' },
    { n: 'Botellín nacional',         b: 'Bien fría' },
    { n: 'Sin alcohol',               b: 'Siempre disponible' },
    { n: 'Vermut de grifo',           b: 'Solo los domingos' },
    { n: 'Sidra natural cántabra',    b: 'Del norte' },
  ]},
  { cat: 'Combinados & Café', items: [
    { n: 'Gin tonic selecto',        b: 'Pregunta carta' },
    { n: 'Whisky con hielo',         b: 'Gran selección' },
    { n: 'Café & cortado',           b: 'Bien cargado' },
    { n: 'Chupito de bienvenida',    b: 'Tradición' },
    { n: 'Licores de la tierra',     b: 'Cántabros' },
  ]},
];

export default function Bebidas() {
  return (
    <>
      <Seo
        title="Bebidas, Vinos y Vermut"
        description="Vinos, cervezas, vermut de grifo, combinados y café en Bar Cabrero (Torrelavega). Blanco de la Nava, Rioja, Txakoli y vermut del domingo. Maridaje perfecto para nuestras gildas."
        path="/bebidas"
        schemas={[breadcrumb([{ name: 'Bebidas y vermut', path: '/bebidas' }])]}
      />

      <section className="sec sec-surf" data-testid="bebidas-page">
        <p className="eyebrow rv">Para beber</p>
        <h1 className="D D-xl rv" style={{ marginBottom: '1rem' }}>La copa que <em>completa el momento.</em></h1>
        <p className="lead rv">
          Elegimos cada bebida pensando en la gilda que la acompaña. Sin pretensiones, con criterio.
        </p>
      </section>

      <section className="sec" data-testid="bebidas-cols">
        <div className="dcols">
          {COLS.map((col) => (
            <div key={col.cat} className="rv" data-testid={`bebidas-col-${col.cat.toLowerCase().replace(/\s|&/g,'')}`}>
              <h3 className="dc-title">{col.cat}</h3>
              <ul className="dlist">
                {col.items.map((it) => (
                  <li key={it.n}><span>{it.n}</span><span className="dbadge">{it.b}</span></li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="maridaje rv">
          <div style={{ width: '4px', background: 'var(--amber)', alignSelf: 'stretch', borderRadius: '2px', flexShrink: 0 }} />
          <div>
            <h4>El maridaje perfecto para una gilda</h4>
            <p>
              Las anchoas de Santoña piden un blanco seco y fresco. El Blanco de la Nava complementa la salinidad y equilibra la guindilla. Si prefieres cerveza, una caña bien fría es imbatible. Para los domingos, el vermut de grifo es la elección de la casa.
            </p>
          </div>
        </div>
      </section>

      <section className="sec sec-verde" data-testid="vermut-domingo">
        <div className="split col2">
          <div>
            <p className="eyebrow rv" style={{ color: 'rgba(255,255,255,0.65)' }}>Evento semanal</p>
            <h2 className="D D-lg rv" style={{ color: '#fff', marginBottom: '1rem' }}>
              El vermut<br /><em style={{ color: 'rgba(255,255,255,0.85)' }}>del domingo.</em>
            </h2>
            <p className="rv" style={{ color: 'rgba(255,255,255,0.8)', lineHeight: 1.8, fontSize: '1rem', maxWidth: '34rem', marginBottom: '1.5rem' }}>
              Cada domingo, de 11:30 a 16h, vermut de grifo, gildas artesanas y la mejor compañía. El aperitivo de Torrelavega tiene una dirección.
            </p>
            <div className="vermut-stats rv">
              {[['11:30–16:00','Solo domingos'], ['Vermut de grifo','Solo este día'], ['Gildas + canapés','Todo el servicio']].map(([n,l]) => (
                <div className="vstat" key={n}><div className="vstat-n">{n}</div><div className="vstat-l">{l}</div></div>
              ))}
            </div>
            <div style={{ display: 'flex', gap: '0.85rem', flexWrap: 'wrap', marginTop: '1.75rem' }}>
              <a className="btn btn-w rv" href={WA_BEBIDAS} target="_blank" rel="noopener noreferrer" data-testid="bebidas-whatsapp">Saludar por WhatsApp</a>
              <Link to="/visitanos" className="btn btn-w rv">Cómo llegar</Link>
            </div>
          </div>
          <div className="vermut-img rv">
            <img src="/dishes/bar-vermut.jpg" alt="Vermut del domingo en Bar Cabrero Torrelavega" loading="lazy" />
          </div>
        </div>
      </section>
    </>
  );
}
